/**
 * LinearReference - Represents linear referencing system information.
 * Used to track alignment references, lookup projects, methods, and overrides for linear features.
 */
export class LinearReference {
  /** Reference method identifier */
  Method: string;

  /** Lookup project identifier */
  LookupProject: string;

  /** Lookup list identifier */
  LookupList: string;

  /** Override value */
  Override: string;

  /** Alignment identifier */
  Alignment: string;

  /**
   * Creates a new LinearReference instance
   * @param data - Object containing linear reference properties
   */
  constructor(data: {
    Method: string;
    LookupProject: string;
    LookupList: string;
    Override: string;
    Alignment: string;
  }) {
    this.Method = data.Method;
    this.LookupProject = data.LookupProject;
    this.LookupList = data.LookupList;
    this.Override = data.Override;
    this.Alignment = data.Alignment;
  }

  /**
   * Creates a LinearReference from a plain object (useful for deserialization)
   * @param obj - Plain object with linear reference data
   * @returns New LinearReference instance
   */
  static fromObject(obj: Partial<LinearReference>): LinearReference {
    return new LinearReference({
      Method: obj.Method ?? "",
      LookupProject: obj.LookupProject ?? "",
      LookupList: obj.LookupList ?? "",
      Override: obj.Override ?? "",
      Alignment: obj.Alignment ?? "",
    });
  }

  /**
   * Converts the LinearReference to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      Method: this.Method,
      LookupProject: this.LookupProject,
      LookupList: this.LookupList,
      Override: this.Override,
      Alignment: this.Alignment,
    };
  }
}


